interface AuthErrors {
  isError: boolean;
  errorCode: number | null;
  errorMessage: string;
}

interface AuthState {
  isLoading: boolean;
  phone: string;
  isOperator: boolean;
  displayName: string | null;
  errors: AuthErrors;
  contactId: string | null;
  codeId: string | null;
  codeExpires: string | null;
  applicationId: string | null;
  isAuth: boolean;
  isFirstApplication: boolean | null;
  isNewClient?: boolean;
  isShortForm?: boolean;
  anonymousId?: string | null;
}

const SET_IS_LOADING = "SET_IS_LOADING";
const SET_AUTH_DATA = "SET_AUTH_DATA";
const SET_AUTH_ERRORS = "SET_AUTH_ERRORS";
const SET_APPLICATION_ID = "SET_APPLICATION_ID";
const SET_ANONYMOUS_ID = "SET_ANONYMOUS_ID";
const SET_CONTACT_ID = "SET_CONTACT_ID";
const SET_IS_AUTH = "SET_IS_AUTH";
const SET_IS_FIRST_APPLICATION = "SET_IS_FIRST_APPLICATION";
const SET_IS_NEW_CLIENT = "SET_IS_NEW_CLIENT";
const SET_IS_SHORT_FORM = "SET_IS_SHORT_FORM";
const SET_AUTH_CODE_ID = "SET_AUTH_CODE_ID";
const SET_AUTH_CODE_EXPIRES = "SET_AUTH_CODE_EXPIRES";
const RESET = "RESET";

interface SetIsLoadingAction {
  type: typeof SET_IS_LOADING;
  payload: boolean;
}

interface SetAuthDataAction {
  type: typeof SET_AUTH_DATA;
  payload: Partial<AuthState>;
}

interface SetAuthErrorsAction {
  type: typeof SET_AUTH_ERRORS;
  payload: AuthErrors;
}

interface SetApplicationIdAction {
  type: typeof SET_APPLICATION_ID;
  payload: string | null;
}

interface SetAnonymousIdAction {
  type: typeof SET_ANONYMOUS_ID;
  payload: string | null;
}

interface SetContactIdAction {
  type: typeof SET_CONTACT_ID;
  payload: string | null;
}

interface SetIsAuthAction {
  type: typeof SET_IS_AUTH;
  payload: boolean;
}

interface SetIsFirstApplicationAction {
  type: typeof SET_IS_FIRST_APPLICATION;
  payload: boolean | null;
}

interface SetIsNewClientAction {
  type: typeof SET_IS_NEW_CLIENT;
  payload: boolean;
}

interface SetIsShortFormAction {
  type: typeof SET_IS_SHORT_FORM;
  payload: boolean;
}

interface SetAuthCodeIdAction {
  type: typeof SET_AUTH_CODE_ID;
  payload: string | null;
}

interface SetAuthCodeExpiresAction {
  type: typeof SET_AUTH_CODE_EXPIRES;
  payload: string | null;
}

interface ResetAction {
  type: typeof RESET;
}

type AuthAction =
  | SetIsLoadingAction
  | SetAuthDataAction
  | SetAuthErrorsAction
  | SetApplicationIdAction
  | SetAnonymousIdAction
  | SetContactIdAction
  | SetIsAuthAction
  | SetIsFirstApplicationAction
  | SetIsNewClientAction
  | SetIsShortFormAction
  | SetAuthCodeIdAction
  | SetAuthCodeExpiresAction
  | ResetAction;

const initialState: AuthState = {
  isLoading: false,
  phone: "",
  isOperator: false,
  displayName: null,
  errors: {
    isError: false,
    errorCode: null,
    errorMessage: "",
  },
  contactId: null,
  codeId: null,
  codeExpires: null,
  applicationId: null,
  isAuth: false,
  isFirstApplication: null,
  isShortForm: false,
};

export const authReducer = (
  state: AuthState = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case SET_IS_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_AUTH_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SET_AUTH_ERRORS:
      return { ...state, errors: action.payload };
    case SET_APPLICATION_ID:
      return { ...state, applicationId: action.payload };
    case SET_ANONYMOUS_ID:
      return { ...state, anonymousId: action.payload };
    case SET_CONTACT_ID:
      return { ...state, contactId: action.payload };
    case SET_IS_AUTH:
      return { ...state, isAuth: action.payload };
    case SET_IS_FIRST_APPLICATION:
      return { ...state, isFirstApplication: action.payload };
    case SET_IS_NEW_CLIENT:
      return { ...state, isNewClient: action.payload };
    case SET_IS_SHORT_FORM:
      return { ...state, isShortForm: action.payload };
    case SET_AUTH_CODE_ID:
      return { ...state, codeId: action.payload };
    case SET_AUTH_CODE_EXPIRES:
      return { ...state, codeExpires: action.payload };
    case RESET:
      return initialState;
    default:
      return state;
  }
};
